import React from "react"

export const CoolButton = ({
	children,
	onClick,
	disabled,
	innerPadding,
	fontSize,
	outerPadding,
	colored = false,
}) => {
	return (
		<div
			className="cool-button-wrapper"
			style={{
				pointerEvents: disabled ? "none" : "auto",
				padding: outerPadding || "0.25rem",
				borderRadius: "1rem",
				backgroundImage: colored
					? "linear-gradient(rgb(79 109 252 / 20%), rgb(96 122 245 / 16%))"
					: "linear-gradient(rgba(214, 211, 209, 0.4), rgba(0, 0, 0, 0))",
				// backgroundImage:
				// 	"linear-gradient(rgba(214, 211, 209, 0.4), rgba(0, 0, 0, 0))",
			}}
		>
			<button
				className="cool-button"
				onClick={onClick}
				style={{
					cursor: "pointer",
					width: "100%",
					border: "none",
					padding: outerPadding || "0.25rem",
					borderRadius: "0.75rem",
					backgroundImage: colored
						? "linear-gradient(rgb(106 132 255), rgb(55, 83, 216))"
						: "linear-gradient(rgb(255, 255, 255), rgba(231, 229, 228, 0.4))",
				}}
			>
				<div
					className="cool-button-content-wrapper"
					style={{
						fontSize: fontSize || "0.9rem",
						padding: innerPadding || "0.5rem",
						borderRadius: "0.5rem",
						backgroundImage: colored
							? "linear-gradient(rgb(55, 83, 216), rgb(76 107 255))"
							: "linear-gradient(rgba(231, 229, 228, 0.4), rgba(255, 255, 255, 0.8))",
						display: "flex",
						justifyContent: "center",
					}}
				>
					{children}
				</div>
			</button>

			<style>{`
				.cool-button {
					box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.5) 0px 1px 3px 0px;
				}
				.cool-button:active {
					transform: matrix(0.995, 0, 0, 0.995, 0, 0);
					box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.5) 0px 0px 1px 0px;
				}

				${
					!colored
						? `
					.cool-button-content-wrapper * {
						color: #111;
						font-weight: 600;
					}
				`
						: ""
				}
			`}</style>
		</div>
	)
}
